import React from 'react';
import ListActions from './ListActions'
import {
	List,
	Responsive,
	SimpleList,
	Datagrid,
	TextField,
	NumberField,
	DateField,
	RichTextField,
	FunctionField,
} from 'admin-on-rest'
import { DocumentationPerformanceFilters } from './Filters'

/**
 * Shows the
 */
export const CollectionPerformance = (props) => (
    <List {...props}
		title="Collection Performance Report"
		filters={<DocumentationPerformanceFilters />}
		actions={<ListActions refreshInterval="900000" />}
		>
		<Responsive
            // small={
            //     <SimpleList
            //         primaryText={record => record.cs_num}
            //     />
            // }
            large={
				<Datagrid>
					<TextField source="label" label="Month" sortable={false} />
					<NumberField source="percentage_proceeds_collected" label="Proc Collected (%)" sortable={false} options={{ maximumFractionDigits: 2, style: 'percent' }} />
					<NumberField source="num_proceeds_collected_w_doc_def" label="Proc Collected w/ Doc Def" sortable={false} />
					<NumberField source="avg_proceeds_collected_w_doc_def" label="Avg Days" sortable={false} options={{ maximumFractionDigits: 2 }} style={{ borderRight: '1px solid #ddd' }} />
					<NumberField source="num_proceeds_collected_wo_doc_def" label="W/o Doc Def" sortable={false} />
					<NumberField source="avg_proceeds_collected_wo_doc_def" label="Avg Days" sortable={false} options={{ maximumFractionDigits: 2 }} style={{ borderRight: '5px solid #ddd' }} />
					<NumberField source="percentage_di_collected" label="DI Collected (%)" sortable={false} options={{ maximumFractionDigits: 2, style: 'percent' }} />
					<NumberField source="num_di_collected_w_doc_def" label="DI Collected w/ Doc Def" sortable={false} />
					<NumberField source="avg_di_collected_w_doc_def" label="Avg Days" sortable={false} options={{ maximumFractionDigits: 2 }} style={{ borderRight: '1px solid #ddd' }} />
					<NumberField source="num_di_collected_wo_doc_def" label="W/o Doc Def" sortable={false} />
					<NumberField source="avg_di_collected_wo_doc_def" label="Avg Days" sortable={false} options={{ maximumFractionDigits: 2 }} />
		        </Datagrid>
            }
        />
    </List>
)



// WEBPACK FOOTER //
// ./src/reports/CollectionPerformance.js